"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "villanova-del-sillaro": {
    "c42f17d3": [{
      "hkey": "18f1b788",
      "slug": "villanova-del-sillaro",
      "name": "Villanova del Sillaro",
      "primary": true,
      "skipSearch": false
    }],
    "galeotta": [{
      "hkey": "18f1b788",
      "slug": "villanova-del-sillaro",
      "name": "Villanova del Sillaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6751bbd6": [{
      "hkey": "18f1b788",
      "slug": "villanova-del-sillaro",
      "name": "Villanova del Sillaro",
      "primary": true,
      "skipSearch": false
    }],
    "mongiardino": [{
      "hkey": "18f1b788",
      "slug": "villanova-del-sillaro",
      "name": "Villanova del Sillaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c8abe910": [{
      "hkey": "18f1b788",
      "slug": "villanova-del-sillaro",
      "name": "Villanova del Sillaro",
      "primary": true,
      "skipSearch": false
    }],
    "san-leone": [{
      "hkey": "18f1b788",
      "slug": "villanova-del-sillaro",
      "name": "Villanova del Sillaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6306f72a": [{
      "hkey": "18f1b788",
      "slug": "villanova-del-sillaro",
      "name": "Villanova del Sillaro",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria": [{
      "hkey": "18f1b788",
      "slug": "villanova-del-sillaro",
      "name": "Villanova del Sillaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;